<template>
  <div class="app">
    <div class="hengtiao1"></div>
    <div class="hengtiao">
      <div class="xiangji"><i class="el-icon-user"></i></div>
      <div class="gerenxinxi">账号注册</div>
    </div>
    <div style="color:black">
      <div class="juzhong1">
        <div class="shenfen selected" @click="selectLogin($event)" :class="{ selected: selectedType === '学生' }">我是学生
        </div>
        <div class="shenfen" @click="selectLogin($event)" :class="{ selected: selectedType === '企业' }">我是企业</div>
      </div>
      <div class="juzhong">
        <div class="fangkuan">
          <div class="juli" v-show="selectedType === 'qiye'">
            <span class="span">*企业税号：</span>
            <el-input placeholder="输入公司税号" prefix-icon="el-icon-document" v-model="taxNumber"
              style="width: 300px;"></el-input>
          </div>
          <div class="juli">
            <span class="span">*手机号：</span>
            <el-input placeholder="输入手机号" prefix-icon="el-icon-phone" v-model="phoneNumber" style="width: 300px;"
              @blur="validatePhone(phoneNumber)">
            </el-input>
          </div>
          <div v-show="rightPhone" class="error">请输入正确的手机号</div>
          <div class="juli">
            <span class="span">*密码：</span>
            <el-input placeholder="输入密码" prefix-icon="el-icon-lock" v-model="password" style="width: 300px;"
              show-password>
            </el-input>
          </div>
          <div class="juli">
            <span class="span">*确认密码：</span>
            <el-input placeholder="再次确认密码" prefix-icon="el-icon-lock" v-model="password2" style="width: 300px;"
              show-password>
            </el-input>
          </div>
          <div v-show="password != password2" class="error">两次密码不一致</div>
          <div class="juzhong" style="margin-top: 20px;">
            <div class="save" @click="save">保存</div>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import Footer from './Footer.vue'
export default {
  name: 'register',
  components: {
    Footer
  },
  data() {
    return {
      phoneNumber: '',
      password: '',
      password2: '',
      selectedType: 'student',
      taxNumber: '',
      BASE_URL: 'https://zhiyedashi.com/info',
      // BASE_URL: 'http://192.168.2.8:8206',
      rightPhone: false
    }
  },
  methods: {
    validatePhone(phone) {
      const phoneRegex = /^1[3-9]\d{9}$/;
      if (!phoneRegex.test(phone)) {
        this.rightPhone = true
      } else {
        this.rightPhone = false
      }
      // console.log(this.rightPhone);
    },
    selectLogin(event) {
      // 移除所有元素的选中状态
      const items = document.querySelectorAll('.shenfen');
      items.forEach(item => item.classList.remove('selected'));

      // 为当前点击的元素添加选中状态
      event.target.classList.add('selected');
      if (event.target.innerText === '我是学生') {
        this.selectedType = 'student'
      } else {
        this.selectedType = 'qiye'
      }
    },
    save() {
      // 判断密码1和密码2是否一致
      if (this.password === this.password2) {
        if (!this.rightPhone) {
          if (this.selectedType === 'student') {
            // 判断数据是否为空
            if (this.phoneNumber === '' || this.password === '') {
              // 说明有的数据为空，提示
              alert("数据不可为空")
            } else {
              // 数据存在的情况
              fetch(`${this.BASE_URL}/admin/user/login/register`, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                  phoneNumber: this.phoneNumber,
                  password: this.password
                })
              })
                .then(res => res.json())
                .then(data => {
                  if (data.code === 200 && data.data === '保存成功') {
                    alert("恭喜您注册成功，请确认跳转登录页面")
                    this.$router.replace('/');
                    window.location.reload(true);
                  } else {
                    alert("手机号已被注册，请重新输入")
                  }
                })
                .catch(error => {
                  console.error("登录失败，原因是", error);
                  alert("注册失败，请稍后再试")
                });
            }
            // 学生保存数据是到学生表
          } else {
            if (this.taxNumber === '' || this.phoneNumber === '' || this.password === '') {
              alert("数据不能为空")
            } else {
              let enterpriseLogin = {
                taxNumber: this.taxNumber,
                phoneNumber: this.phoneNumber,
                password: this.password
              };

              fetch(`${this.BASE_URL}/admin/enterprise/login/register`, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify(enterpriseLogin)
              })
                .then(res => res.json())
                .then(data => {
                  if (data.code === 200 && data.data === '注册成功') {
                    // 处理成功
                    this.$router.replace('/');
                    window.location.reload(true);
                  } else {
                    alert("税号已被注册，请重新输入")
                  }
                })
                .catch(error => {
                  console.error("注册失败，原因是", error);
                  alert("注册失败，请稍后再试");
                });
            }
            // 企业保存数据到企业表
          }
        } else {
          alert("请输入正确的手机号")
        }
      } else {
        alert("请重新核对密码")
      }
    }
  }
}
</script>

<style scoped>
.error {
  color: red;
  margin-left: 137px;
  font-size: 14px;
}

.save {
  background-color: #3572e5;
  height: 40px;
  width: 200px;
  border-radius: 10px;
  color: white;
  font-weight: 700;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.juli {
  display: flex;
  margin-top: 20px;
  margin-left: 20px;
}

.kuandu {
  width: 300px;
}

.span {
  display: block;
  width: 110px;
  padding: 5px;
}

.fangkuan {
  height: 450px;
  width: 470px;
  border: 3px solid rgb(134, 132, 132);
  text-align: left;
  font-size: 20px;
  margin-top: 20px;
  border-radius: 30px;
}

.hengtiao1 {
  height: 8px;
  width: 100%;
  background-color: white;
  display: flex;
  align-items: center;
}

.hengtiao {
  height: 50px;
  width: 100%;
  background-color: #3572e5;
  color: white;
  display: flex;
  align-items: center;
}

.xiangji {
  margin-left: 20px;
  font-weight: 800;
  font-size: 28px;
}

.gerenxinxi {
  margin-left: 20px;
  font-weight: 700;
}

.juzhong {
  display: flex;
  justify-content: center;
  align-items: center;
}

.juzhong1 {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 50px;
  gap: 60px;
}

.junfen {
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.shenfen {
  padding: 5px 15px;
  font-weight: 700;
  font-size: 22px;
  border: 1px solid #c5ced7;
  border-radius: 10px;
  cursor: pointer;
}

.shenfen.selected {
  background-color: #3f4e63;
  color: white;
}

@media (max-width: 768px) {
  .error {
    margin-left: 20px;
    font-size: 12px;
  }

  .save {
    height: 35px;
    width: 150px;
    border-radius: 8px;
    font-size: 16px;
  }

  .juli {
    margin-top: 15px;
    margin-left: 15px;
    flex-direction: column;
  }

  .span {
    width: 100%;
    padding: 3px;
    font-size: 16px;
  }

  .fangkuan {
    height: auto;
    width: 90%;
    font-size: 16px;
    margin-top: 15px;
    border-radius: 20px;
    padding-bottom: 20px;
  }

  .hengtiao {
    height: 40px;
  }

  .xiangji {
    font-size: 20px;
  }

  .juzhong1 {
    margin-top: 30px;
    gap: 30px;
  }

  .shenfen {
    font-size: 18px;
    padding: 4px 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/register.vue